import { getTelegramUser } from '../utils'

export const useTelegramUser = () => {
  return getTelegramUser()
}
